import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  kitLists: [],
  states: [],
  districts: [],
  agencies: [],
  filterStatus: [],
  projects: [],
  samplers: [],
  kitListsCount: 0,
  kitDataAfterKitCreation: {},
  logisticList: [],
  filterDistricts: [],
  filterSamplers: [],
  sealTypes: [],
};

const assetManagementSlice = createSlice({
  name: "assetManagement",
  initialState,
  reducers: {
    fetchKitLists(state, action) {
      state.loading = true;
    },
    fetchKitListsSuccess(state, action) {
      state.kitLists = action.payload.data?.document || [];
      state.kitListsCount = action.payload.data.paginationMetadata.total;
      state.loading = false;
    },
    fetchKitListsFailure(state, action) {
      state.loading = false;
    },
    fetchStates(state, action) {
      state.states = [];
      state.districts = [];
      state.samplers = [];
    },
    fetchStatesSuccess(state, action) {
      state.states = action.payload.data.document || [];
    },
    fetchStatesFailure(state, action) {},
    fetchDistricts(state, action) {
      const { For } = action.payload || {};
      if (For === "filter") {
        state.filterDistricts = [];
        state.filterSamplers = [];
      } else {
        state.districts = [];
        state.samplers = [];
      }
    },
    fetchDistrictsSuccess(state, action) {
      const { For } = action.payload;
      if (For === "filter") {
        state.filterDistricts = action.payload.data?.data?.districts || [];
      } else {
        state.districts = action.payload.data?.data?.districts || [];
      }
    },
    fetchDistrictsFailure(state, action) {},
    fetchAgency(state, action) {},
    fetchAgencySuccess(state, action) {
      state.agencies = action.payload?.data?.documents || [];
    },
    fetchAgencyFailure(state, action) {},

    fetchStatus(state, action) {},
    fetchStatusSuccess(state, action) {
      state.filterStatus =
        action.payload?.data?.document?.samplerKitStatus || [];
    },
    fetchStatusFailure(state, action) {},

    fetchProjects(state, action) {},
    fetchProjectsSuccess(state, action) {
      state.projects = action.payload?.data || [];
    },
    fetchProjectsFailure(state, action) {},

    fetchSamplers(state, action) {
      const { For } = action.payload || {};
      if (For === "filter") {
        state.filterSamplers = [];
      } else {
        state.samplers = [];
      }
    },
    fetchSamplersSuccess(state, action) {
      const { For } = action.payload;
      if (For === "filter") {
        state.filterSamplers = action.payload?.data?.data?.sampler || [];
      } else {
        state.samplers = action.payload?.data?.data?.sampler || [];
      }
    },
    fetchSamplersFailure(state, action) {},

    createKitSeals(state, action) {
      state.kitDataAfterKitCreation = {};
    },
    createKitSealsSuccess(state, action) {
      state.kitDataAfterKitCreation = action.payload?.data || {};
    },
    createKitSealsFailure(state, action) {},
    kitAssignToSampler(state, action) {},
    kitAssignToSamplerSuccess(state, action) {},
    kitAssignToSamplerFailure(state, action) {},

    updateKitStatus(state, action) {},
    updateKitStatusSuccess(state, action) {},
    updateKitStatusFailure(state, action) {},

    getLogisticList(state, action) {},
    getLogisticListSuccess(state, action) {
      state.logisticList = action.payload?.data?.document || [];
    },
    getLogisticListFailure(state, action) {},

    assignLogisticToKit(state, action) {},
    assignLogisticToKitSuccess(state, action) {},
    assignLogisticToKitFailure(state, action) {},

    getSampleSealTypes(state, action) {},
    getSampleSealTypesSuccess(state, action) {
      state.sealTypes = action.payload?.data?.sealTypes || [];
    },
    getSampleSealTypesFailure(state, action) {},
  },
});

export const { actions, reducer, name: sliceKey } = assetManagementSlice;
